export const ANALYTICS_INTEGRATION_LIST = 'analyticsIntegrationList'
export const ANALYTICS_INTEGRATION_FILTER_MO = 'analyticsIntegrationFilterMo'
export const ANALYTICS_INTEGRATION_FILTER_EXT_SYSTEMS = 'analyticsIntegrationFilterExtSystems'
export const ANALYTICS_INTEGRATION_FILTER_EHR = 'analyticsIntegrationFilterEhr'
export const ANALYTICS_INTEGRATION_FILTER_DEPARTS = 'analyticsIntegrationFilterDeparts'
